import { render, staticRenderFns } from "./GenericCard.vue?vue&type=template&id=f23f0e20&lang=pug&"
import script from "./GenericCard.vue?vue&type=script&lang=js&"
export * from "./GenericCard.vue?vue&type=script&lang=js&"
import style0 from "./GenericCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports